  <template>
  <div class="live">
    <div class="title">
      <h3 @click="goback()">
        <i class="el-icon-arrow-left">
          {{ id ? $t('active.editactive') : $t('homepage.addactive') }}
        </i>
        <span>{{ $t('common.required1') }}<i>*</i>{{ $t('common.required2') }}</span>
      </h3>
    </div>
    <div class="tixing">
      <h4>{{ $t('common.importantremind') }}</h4>
      <p>
        {{ $t('common.suggest1') }}<i>{{ $t('active.date') }}</i>{{ $t('common.suggest2') }}
      </p>
    </div>
    <!-- 表单元素-------------------------- -->
    <div class="formdata">
      <el-form ref="form" :model="formInfo" :rules="rules" label-width="200px" size="mini" :disabled="flag == '2' || flag == '0' ? true : false">
        <el-form-item :label="$t('active.activeType')+':'" :required="true" prop="activeType">
          <el-row>
            <el-radio v-model="formInfo.activeType" label="技术交流会"> {{ $t('active.technology') }}</el-radio>
            <el-radio v-model="formInfo.activeType" label="产品发布会">{{ $t('active.productLanuch') }}</el-radio>
            <el-radio v-model="formInfo.activeType" label="展台活动">{{ $t('active.boothActiv') }}</el-radio>
            <el-radio v-model="formInfo.activeType" label="其他">{{ $t('active.other') }}</el-radio>
          </el-row>
         
        </el-form-item>
        <el-form-item :label="$t('active.cnActiveName')+':'" prop="actTitle">
          <el-input v-model="formInfo.actTitle" :placeholder="$t('active.placeholder')" maxlength="50" show-word-limit></el-input>
        </el-form-item>

        <el-form-item :label="$t('active.enActiveName')+':'" prop="column16">
          <el-input v-model="formInfo.column16" :placeholder="$t('active.placeholder')" maxlength="50" show-word-limit></el-input>
        </el-form-item>




        <!-- 开始时间 -->
        <el-form-item  :label="$t('common.startdate')+':'" prop="startTime">
          <div class="begin">
            <!--  时间日期选择器 -->
            <el-date-picker v-model="dateTime.beginyear"
            value-format="yyyy-MM-dd"
            type="date"
            :placeholder="$t('active.selectDate')"
            :picker-options="pickerOptions"
             @focus="clickStartTime"
            > </el-date-picker>

            <el-select v-model="dateTime.beginHour" :placeholder="$t('common.select')">
              <el-option v-for="item in dateTime.beginTimeHour" :key="item.value" :label="item.label"  :disabled="item.disabled" :value="item.value"> </el-option>
            </el-select>
            <span class="mao">:</span>
            <el-select v-model="dateTime.beginSecond" :placeholder="$t('common.select')">
              <el-option v-for="item in dateTime.beginTimeMinute" :key="item.value"  :disabled="item.disabled" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
        </el-form-item>
        <!-- 结束时间 -->




        <el-form-item  :label="$t('common.enddate')+':'" prop="endTime">
          <div class="begin">
            <!--  时间日期选择器 -->
            <el-date-picker v-model="dateTime.endyear" value-format="yyyy-MM-dd" type="date"
                  @focus="clickEndTime"
             :picker-options="endTimeOptions"
            :placeholder="$t('active.selectDate')"> </el-date-picker>
            <el-select v-model="dateTime.endHour" :placeholder="$t('common.select')">
              <el-option v-for="item in dateTime.beginTimeHour" :key="item.value" :disabled="item.disabled" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            <span class="mao">:</span>
            <el-select v-model="dateTime.endSecond" :placeholder="$t('common.select')">
              <el-option v-for="item in dateTime.beginTimeMinute" :key="item.value" :disabled="item.disabled" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
        </el-form-item>





        <!-- 活动地点 -->
        <el-form-item  :label="$t('active.activeAddress')+':'" prop="address">
          <el-input v-model="formInfo.address"  :placeholder="$t('active.placeholder1')"></el-input>
        </el-form-item>

        <!-- upload新增  活动图片-->
        <el-form-item :label="$t('active.activePhote')+':'" prop="column15">
          <!-- 上传封面部分 -->
          <div class="upload-logo qrcode">
            <div :style="{ background: 'url(' + spliceUrl(formInfo.column15) + ') #f1f1f1 no-repeat center  /contain' }" class="upload-logo qrcode">
              <img alt="删除" src="../../../static/icon_del.png"  v-if="flag === '' || flag === '-1'" @click="deleteImg('coverImg')" />
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="imgbaseUrl + '/hz/frontCommon/upload'"
                :headers="getToken()"
                name="file"
                :on-error="handleError"
                :on-success="handleSuccess"
                :show-file-list="false"
                :before-upload="
                  (file) => {
                    return coverBefore(file);
                  }
                "
              >
                <div class="el-upload__text" v-if="flag === '' || flag === '-1'">{{ $t('common.selectfile') }}</div>
              </el-upload>
            </div>
          </div>

          <!-- 上传封面部分 -->
          <p class="tishi">
            <!-- 格式：jpg, png, gif; 建议尺寸：693*399px; 大小：2M内 -->
             {{$t('common.uploadimg1', { format: 'jpg, png, gif', recomsize:'693*399',filesize:'500kb'}) }}
          </p>
        </el-form-item>

        <!--------------------直播简介------------------------->
        <!-- :label="$t('active.activePhote')+':'" -->
        <el-form-item :label="$t('active.activeIntroCh')+':'" prop="actContent">
          <template v-if="flag == 2 || flag == '0'">
            <!-- <div v-html="formInfo.actContent"></div> -->
               <div class="tinymce">
            <tinymce
              ref="column"
              v-model="formInfo.actContent"
              :data="formInfo.actContent"

            >
            </tinymce>
             </div>
          </template>
          <template v-else>
            <div class="editor1">
            <tinymce ref="tinymceCh" :data="formInfo.actContent"></tinymce>
            </div>
          </template>

        </el-form-item>

        <!--------------------直播简介 英文------------------------->
        <el-form-item :label="$t('active.activeIntroEn')+':'" prop="introduce">
          <template v-if="flag == 2 || flag == '0'">
           <div class="tinymce">
            <tinymce ref="tinymceEn" :data="formInfo.introduce"  v-model="formInfo.actContent"></tinymce>
              </div>
          </template>
          <template v-else>
              <div class="editor1">
            <tinymce ref="tinymceEn" :data="formInfo.introduce"></tinymce>
              </div>
          </template>

        </el-form-item>
        <!-- 审核不通过原因 -->
        <div class="btn">
          <div class="why"  v-if="flag === '-1'">
           {{ $t('active.noPass') }}
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">{{ formInfo.cause }}</div>
              <router-link to="#"> {{ $t('active.cause') }}</router-link>
            </el-tooltip>
          </div>
        </div>

        <el-button type="primary" class="button" v-if="flag === '2'">{{ $t('active.inreview') }}</el-button>
        <el-button type="primary" class="button" v-if="flag === '0'">{{ $t('active.approve') }}</el-button>
        <el-button type="primary" class="button" @click="submitForm(formInfo)" v-if="flag === '' || flag === '-1'">{{ $t('common.submit') }}</el-button>

      </el-form>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
      <span>{{ $t('active.hint') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="check">{{ $t('active.submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tinymce from '../../comment/tinymce.vue';
import tinymce2 from '../../comment/tinymce.vue';

import { forMat } from '../../../../utils/common.js';
import { getExhition } from '../../../../api/exhibitor.js';
import { addLive, getActive, editLive } from '../../../../api/active.js';

export default {

  name: 'addExhiLive',
  data() {
    var validatorStartTime = (rule, value, callback) => {
      if (!this.dateTime.beginyear || !this.dateTime.beginHour || !this.dateTime.beginSecond) {
        callback(new Error('活动开始时间不能为空!'));
      } else {
        callback();
      }
    };
    var validatorEndTime = (rule, value, callback) => {
      if (!this.dateTime.endyear || !this.dateTime.endHour || !this.dateTime.endSecond) {
        callback(new Error('活动结束时间不能为空!'));
      } else {
        callback();
      }
    };
    var validatorColumn15 = (rule, value, callback) => {
      if(!this.formInfo.column15){
        callback(new Error('活动照片不能为空!'));
      }else{
        callback();
      }
    };
    var validatorActContent = (rule, value, callback)=>{
      const content = this.$refs.tinymceCh.getContent()
      if(!content){
        callback(new Error('活动简介·中文不能为空!'));
      }else{
        callback();
      }
    }
    return {
      id: this.$route.query.id,
      exhId: '', //展商id
      dialogVisible: false, // 控制弹框开启和关闭
      imgbaseUrl: '',
      formInfo: {
        id: '',
        exhId: '', //展商id
        actTitle: '', //活动名称
        column16: '', //活动英文名字
        startTime: '', //开始时间
        endTime: '', //结束时间
        column15: '', //封面图片
        activeType: '技术交流会', //活动类型
        address: '', //活动地址
        actContent: '', //	活动简介-中
        introduce: '', // 活动简介-英文
      },
     
      flag: '',
      //时间日期格式
      dateTime: {
        beginyear: '',
        beginHour: '',
        beginSecond: '',
        endyear: '',
        endHour: '',
        endSecond: '',
        beginTimeHour: [],
        beginTimeMinute: [],
      },
      //日期选择器
  /*     pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
        ],
      }, */



      //规则限制，不可选择今天之前的时间日期
      pickerOptions: {
        disabledDate(v) {
            return v.getTime() <= new Date().getTime() - 86400000;
        }
      },

      startTimeOptions:{},  //开始时间
      endTimeOptions:{},   //结束时间


    };
  },
  components: {
    tinymce,
    tinymce2,
  },
  computed:{
    rules(){
       var validatorStartTime = (rule, value, callback) => {
      if (!this.dateTime.beginyear || !this.dateTime.beginHour || !this.dateTime.beginSecond) {
        callback(new Error(this.$t('dialog.startTime')));
      } else {
        callback();
      }
    };
    var validatorEndTime = (rule, value, callback) => {
      if (!this.dateTime.endyear || !this.dateTime.endHour || !this.dateTime.endSecond) {
        callback(new Error(this.$t('dialog.endTime')));
      } else {
        callback();
      }
    };
    var validatorColumn15 = (rule, value, callback) => {
      if(!this.formInfo.column15){
        callback(new Error(this.$t('dialog.actiPict')));
      }else{
        callback();
      }
    };
     var validatorActContent = (rule, value, callback)=>{
      const content = this.$refs.tinymceCh.getContent()
      if(!content){
        callback(new Error(this.$t('dialog.actTextEn')));
      }else{
        callback();
      }
    };

    return{
        activeType: [{ required: true, message:this.$t('dialog.tishi1') , trigger: 'blur' }],
        actTitle: [{ required: true, message: this.$t('dialog.tishi2'), trigger: 'blur' }],
        // column16: [{ requir'请选择活动类型'ed: true, message: '请输入活动名称·英文', trigger: 'blur' }],
        startTime: [{ required: true, trigger: 'blur',message: this.$t('dialog.tishi3'), }, { validator: validatorStartTime }],
        endTime: [{ required: true, trigger: 'blur',message: this.$t('dialog.tishi4'), }, { validator: validatorEndTime }],
        address: [{ required: true, message:  this.$t('dialog.tishi5'), trigger: 'blur' }],
        column15: [{ required: true, trigger: 'blur',message:  this.$t('dialog.tishi6') }, { validator: validatorColumn15 }],
        actContent: [{ required: true, trigger: 'blur',message:  this.$t('dialog.tishi7')  }, { validator: validatorActContent }]

    }

    }




  },
  created() {
    this.init();
    this.getItem();

  },
  methods: {

          //开始结束时间限制
      clickStartTime() {
        this.startTimeOptions.disabledDate = time => {
          if (this.dateTime.beginyear) {
             if (time.getTime() > new Date(this.dateTime.beginyear).getTime()) {
              return true
            }
            if (time.getTime() < Date.now() - 8.64e7) {
              return true
            }
          }
          else {
             if (time.getTime() < Date.now() - 8.64e7) {
              return true
            }
          }
        }
      },
      clickEndTime(){
        this.endTimeOptions.disabledDate = time => {
          if (this.dateTime.beginyear) {
            return (
                 time.getTime() > Date.now - 8.64e7 || time.getTime() <= new Date(this.dateTime.beginyear).getTime()- 8.64e7
            )
          } else {
            return time.getTime() < Date.now() - 8.64e7
          }
        }
    },

    goback() {
      this.$router.push('/backIndex/active_list');
    },
    async getItem() {
      if (this.id) {
        const params = {
          id: this.id,
        };
        try {
          const { data } = await getActive(params);
          if (data.code === 200) {
            this.formInfo = data.data;
            const start = data.data.startTime;
            const end = data.data.endTime;

            this.dateTime.beginyear = start.substring(0, 10);
            this.dateTime.beginHour = start.substring(11, 13);
            this.dateTime.beginSecond = start.substring(14, 16);
            this.dateTime.endyear = end.substring(0, 10);
            this.dateTime.endHour = end.substring(11, 13);
            this.dateTime.endSecond = end.substring(14, 16);
            this.flag = data.data.auditFlag
          }
        } catch (err) {
          this.$message.error(err);
        }
      }
    },
    check() {
      this.dialogVisible = false;
      this.$router.push('/backIndex/active_list');
      // this.$message({
      //   message: '新增活动成功!',
      //   type: 'success',
      // });
    },
    async init() {
      try {
        const { data } = await getExhition();
        this.exhId = data.data.id;
      } catch (err) {
        this.$message.error(err);
      }
    },
    handleClose() {},
    //返回的url
    spliceUrl(img) {
      if(img.indexOf("http")  == -1){
            img= this.imgbaseUrl + img;
          }
      return  img;
    },
    //获取token
    getToken() {
      const a = localStorage.getItem('token');
      let token = {};
      token.token = a;
      return token;
    },
    //提交函数
    async submit(addData) {
      delete this.formInfo.hzBoothList;
      delete this.formInfo.hzExhibitor;

      if (this.id) {
        addData.id = this.id;
        try {
          const { data } = await editLive(this.formInfo);
          if (data.code === 200) {
            this.dialogVisible = true;
          }
        } catch (err) {
          this.$message.error(err);
        }
      } else {
        try {
          const { data } = await addLive(this.formInfo);
          if (data.code === 200) {
            this.dialogVisible = true;
          }
        } catch (err) {
          this.$message.error(err);
        }
      }
    },
    //提交函数
    submitForm() {
      console.log(this.dateTime.beginyear, this.dateTime.beginHour, this.dateTime.beginSecond);
      this.forMatDate(); //时间日期整合
      const Ch = this.$refs.tinymceCh.getContent(); //获取富文本的内容
      const En = this.$refs.tinymceEn.getContent();
      this.formInfo.actContent = Ch;
      this.formInfo.introduce = En;
      this.formInfo.exhId = this.exhId;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submit(this.formInfo);
        } else {
        }
      });
    },
    //封面信息提示
    coverBefore(file) {
      const size = file.size / 1024 < 500;
      if (!size) {
        this.$message({ message: this.$t('dialog.message6'), type: 'warning' });
        return false;
      }
    },
    //封面图片上传
    handleSuccess(file) {
      file.code == 200 ? (this.formInfo.column15 = file.data.url) : '';
    },
    // //封面图片上传失败
    // handleError() {
    //   console.log('上传失败！');
    // },
    //删除图片
    deleteImg(arg) {
      arg == 'coverImg' ? (this.formInfo.column15 = '') : '';
      // arg == 'coverVideoType' ? (this.formInfo.videoAddress = '') : '';
    },

    handleError(file) {
      console.log(file, '封面上传失败');
    },
    //随机数产生
    productRandom(endTime, limit) {
      let dateArr = [];
      for (let i = 0; i <= endTime; i++) {
        i < limit ? (i = '0' + i) : (i = i.toString());
        let obj = {};
        obj.value = i;
        obj.label = i;
        dateArr.push(obj);
      }
      return dateArr;
    },
    //时间日期处理
    forMatDate() {
      let startTime = null;
      let endTime = null;
      startTime = this.dateTime.beginyear + ' ' + this.dateTime.beginHour + ':' + this.dateTime.beginSecond;
      endTime = this.dateTime.endyear + ' ' + this.dateTime.endHour + ':' + this.dateTime.endSecond;
      this.formInfo.startTime = startTime;
      this.formInfo.endTime = endTime;
    },
    quit() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.dateTime.beginTimeHour = this.productRandom(23, 10);
    this.dateTime.beginTimeMinute = this.productRandom(59, 10);
    this.imgbaseUrl = forMat();
  },
};
</script>

<style lang="scss" scoped>
.editor1{
  width: 800px;
}
.tinymce {
   width: 800px;
  // height: 260px;
  // border: 1px solid red;
  pointer-events: none;

  z-index: 9999;

}
.why{
  font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff190c;
    line-height: 20px;
    margin-left: 199px;
    margin-bottom: 10px;
}
.live {
  box-sizing: border-box;
  padding: 18px 26px 30px 0;
  background-color: white;
  .title {
    height: 55px;
    padding-left: 26px;
    border-bottom: 1px solid #e8e8e8;
    h3 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      cursor: pointer;
      span {
        margin-left: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        i {
          font-style: normal;
          color: red;
        }
      }
    }
  }
  .tixing {
    margin-left: 26px;
    margin-bottom: 40px;
    background: #f6f6f7;
    padding: 10px 30px;
    margin-top: 16px;
    h4 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff190c;
      line-height: 19px;
      margin-bottom: 9px;
      //margin-top: 26px;
    }
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 19px;
      i {
        font-style: normal;
        color: red;
      }
    }
  }
  .formdata {
    width: 650px;
    margin-top: 48px;
    // margin: 0 auto;
    .tishi {
      margin-top: 30px;
      font-size: 12px;
      color: #999999;
    }
    .editor {
      width: 463px;
      height: 193px;
    }
    .shangchuan {
      width: 208px;
      height: 117px;
      border: 1px solid #e9e9e9;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f1f1f1;
      button {
        width: 94px;
        height: 28px;
        color: #666;
        background: white;


      }
    }
    .button {
      margin-left: 201px;
    /*   background: #006fb8; */
      background: #006fb8 !important;

    }
  }
}
</style>
<style scoped>
.upload-demo >>> .el-upload-dragger {
  width: 225px;
  height: 173px;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px;
}
.upload-demo >>> .el-upload__text {
  width: fit-content;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  width: 93px;
  height:fit-content;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 14px;
  padding: 5px;
}
.begin {
  display: flex;
  justify-content: space-between;
}
.mao {
  margin: 5px;
  position: relative;
  top: -5px;
  left: 5px;
}
.begin >>> .el-select {
  margin-left: 17px;
}
</style>
<style scoped>
.Addimg {
  width: 225px;
  height: 173px;
  margin-right: 20px;
}
.upload-demo >>> .el-upload-list__item {
  width: 225px;
  height: 173px;
}
.live >>> .el-dialog__header {
  background: #006fb8;
  padding: 10px;
}
.live >>> .el-dialog__title {
  color: white;
}
.live >>> .el-button--primary {
/*   background: #006fb8; */
 background: #9fa2a3;
}



.formdata >>> .el-button{
   padding: 7px 17px !important;
}
</style>
<style lang="scss" scoped>
//上传组件样式
.upload-logo {
  width: 363px;
  height: 209px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  &.qrcode {
    width: 360px;
    height: 240px;
  }
  &video {
    width: 200px;
    height: 140px;
  }
  img {
    position: absolute;
    right: 0;
    top: 0px;
    cursor: pointer;
  }

  .upload-demo {
    align-self: center;
  }
}
</style>
